/**
 * Sidebar Icon
 *
 */

export default function logos(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="11.25" stroke="black" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="7.25" stroke="black" strokeWidth="1.5" />
    </svg>
  )
}
